import { createSlice } from '@reduxjs/toolkit';
const token = localStorage.getItem('token');
const observeApiKey = localStorage.getItem("observeearth_api_key") || localStorage.getItem("observearth_api_key");

if (token && !observeApiKey) {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("Is_Superuser");
  localStorage.removeItem("observeearth_api_key");
  localStorage.removeItem("observearth_api_key");
}

const initialState = {
  rootApiUrl: process.env.REACT_APP_ROOT_API_URL || 'http://127.0.0.1:8000/',
  isLogedIn: (token && observeApiKey) ? true : false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setIsLogedIn(state, action) {
      state.isLogedIn = action.payload;
    },
  },
});

export const globalAct = globalSlice.actions;

export default globalSlice.reducer;
